import { FC, useMemo } from 'react'
import { Img } from '../../../Components/Image/Img'
import {
  WeekendCardRoot,
  CardContent,
  EventInfoWrapper,
  EventHeader,
  EventLocation,
  HomecomingBadge,
  EventDetails,
  DetailItem,
  ActionsWrapper,
  SideBarIndicator,
} from './WeekendCard.styles'
import {
  checkSpecialWeek,
  getMarketSlug,
  getTeamIc,
  getWeekendRange,
  isHomecomingWeekend,
} from '../../../Utils'
import { Desc, Head3 } from '../../../Components/Typography/Text.styles'
import { EventGQL } from '../../../Api'
import { MapRoundedIcon } from '../../../Components/LazyComponents'
import { TicketsButton } from '../../Schedule/components/weekBox/HeaderActions/ticketSelector/TicketsButton'

export const WeekendCard: FC<{ events: EventGQL[] }> = ({ events }) => {
  const specialWeek = useMemo(
    () => (events.length < 1 ? null : checkSpecialWeek(events[0], true)),
    [events]
  )
  const market = useMemo(() => getMarketSlug(events[0].location), [events])
  const homecomingTeam = isHomecomingWeekend(market, events[0].seasonSegment)

  if (!events.length) return null

  return (
    <WeekendCardRoot>
      <SideBarIndicator />
      <CardContent>
        <EventInfoWrapper>
          <DetailItem sideMargins={2}>
            <Head3>{getWeekendRange(events, [])}</Head3>
          </DetailItem>
          <EventHeader>
            <EventLocation>{events[0].location}</EventLocation>
          </EventHeader>

          <EventDetails>
            <DetailItem sideMargins={2}>
              <MapRoundedIcon fontSize="medium" />
              <Desc>{events[0].venue}</Desc>
            </DetailItem>
            {specialWeek && (
              <DetailItem>
                {homecomingTeam && (
                  <HomecomingBadge>
                    <Img
                      src={getTeamIc(homecomingTeam)}
                      alt={`${homecomingTeam} logo`}
                    />
                  </HomecomingBadge>
                )}
                <Desc>{specialWeek}</Desc>
              </DetailItem>
            )}
          </EventDetails>
        </EventInfoWrapper>

        <ActionsWrapper>
          <TicketsButton
            event={events[0]}
            week={events[0].week}
            waitList={false}
            dayTickets={[]}
            market={market}
            location="Tickets_Page"
          />
        </ActionsWrapper>
      </CardContent>
    </WeekendCardRoot>
  )
}
